<template>
    <div class="homepage">
        <page-header :title="$t('home.title')" />
        <ion-grid>
            <ion-row>
                <ion-col v-for="user in users" :key="user.id" size-xs="6" size-sm="6" size-md="4" size-lg="3">
                    <user-card :user="user" />
                </ion-col>
            </ion-row>
        </ion-grid>
        <ion-button class="more-btn" @click="goToSearch" color="secondary" shape="round">{{ $t('master.more') }}</ion-button>
        <ad-leaderboard />
    </div>
</template>

<script>
import UserCard from '@/components/UserCard'
import PageHeader from '@/components/PageHeader'
import AxiosController from '@/controllers/AxiosController'
import { isMobile } from 'mobile-device-detect'
import { constants } from '../constants'
import AdLeaderboard from '@/components/AdLeaderboard'

export default {
    name: 'HomeMobile',
    components: {
        UserCard,
        PageHeader,
        AdLeaderboard
    },
    data() {
        return {
            constants,
            users: [],
            isMobile
        }
    },
    mounted() {
        AxiosController.get('/search').then(res => {
            this.users = res.data
        })
    },
    methods: {
        goToSearch() {
            this.$router.push('/search')
        }
    }
}
</script>

<style lang="scss" scoped>
.banner {
    margin: 20px 10px;
}

@media (min-width: 768px) {
    .more-btn {
        width: 100px;
        margin-top: 30px;
        margin-bottom: 40px;
    }
}
</style>
